import {AfterViewInit, Component, HostListener, inject, OnInit} from '@angular/core';
import {PrimeNGConfig} from 'primeng/api';
import {LanguageService} from "./shared/services/language.service";
import {ConfigService} from "./config.service";
import {UserService} from "./shared/services/user.service";
import {UserPropertiesService} from "./sipo/services/user-properties.service";
import {TranslateService} from "@ngx-translate/core";
import {APP_CONFIG} from "./app-config";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {

    cfg = inject(APP_CONFIG);

    constructor(private primengConfig: PrimeNGConfig,
                private languageService: LanguageService,
                private configService: ConfigService,
                private userService: UserService,
                private userPropertiesService: UserPropertiesService,
                private translateService: TranslateService) {


    }

    ngAfterViewInit(): void {

    }

    ngOnInit(): void {
        this.primengConfig.ripple = true;
        this.getLoggedInUserInComponentEvent();
        this.getUserLangProperty();
    }

    getLoggedInUserInComponentEvent(): void {
        this.userService.getLoggedInUser().subscribe(loggedInUser => {
            if (loggedInUser) {
                this.configService.currentUser$.next(loggedInUser);
                this.configService.currentUser = loggedInUser;
            }
        });
    }

    getUserLangProperty() {
        this.userPropertiesService.getByKey('sipo.settings.language').subscribe(
            lang => {
                if (lang?.userPropertyValue) {
                    this.translateService.use(lang?.userPropertyValue)
                }
            }
        )
    }

    @HostListener('document:click', ['$event'])
    handleGlobalClick(event: MouseEvent) {
        this.getLoggedInUserInComponentEvent();
    }
}
